import React from "react";

function Video() {
  return (
    <video width="100%" height="480" controls>
      <source src="/assets/contact.mp4" type="video/mp4" />
    </video>
  );
}

export default Video;
